module.exports = __webpack_public_path__ + "static/media/rentalcar.fde2c021.jpg";